<template>
  <div class="content usuario">
    <h1><span><i class="fas fa-user-circle"></i> Usuários</span></h1>

    <b-tabs pills nav-class="mb-5 mt-5" lazy>
      <b-tab title="Usuários" @click="changeRouter('usuario')" :active="isActive('usuario')" v-if="empresaId === empresaJaleko">
        <ListaUsuarios />
      </b-tab>
      <b-tab title="Usuários" @click="changeRouter('usuario')" :active="isActive('usuario')" v-else>
        <ListaUsuariosB2B />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ListaUsuarios from './components/ListaUsuarios'
import ListaUsuariosB2B from './components/ListaUsuariosB2B'
import EmpresaUtils from '@/core/util/empresa-utils'
import Empresas from '@/core/constants/empresas'

export default {
  name: 'UsuarioView',
  components: { ListaUsuarios, ListaUsuariosB2B },

  data () {
    return {
      empresaId: EmpresaUtils.getEmpresa().id,
      empresaJaleko: Empresas.JALEKO
    }
  },

  methods: {
    isActive: function (tab) {
      return this.$route.params.activeTab === tab
    },

    changeRouter: function (tab) {
      this.$router.push(`/usuario/${tab}`)
    }
  }
}
</script>

<style scoped>

</style>
